export default __webpack_public_path__ + "static/media/briefcase.bb4bb82f.svg";